import React from 'react';
import './invoice-issue-status.scss';
import { Text, View } from '../../common';
import {
  getInvoiceIssueStatusStyle,
  getInvoiceStatus,
  getInvoiceStatusStyle,
} from '../../helper';

interface InvoiceIssueStatusProps {
  invoiceStatus: string;
}

export const InvoiceIssueStatus: React.FC<InvoiceIssueStatusProps> = ({
  invoiceStatus,
}) => {
  const style = getInvoiceIssueStatusStyle(invoiceStatus);
  return (
    <View className={`invoice-issue-status ${style.backgroundClass}`}>
      <Text
        className={`invoice-issue-status-text font-medium ${style.textClass}`}
      >
        {getInvoiceStatus(invoiceStatus)}
      </Text>
    </View>
  );
};
